import { createStyles } from 'antd-style';

const useHeaderActionStyles = createStyles(({ token, css }) => ({
  action: css`
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    height: 36px !important;
    min-width: 36px;
    padding-block: 0 !important;
    padding-inline: 8px !important;
    border-radius: ${token.borderRadius}px !important;
  `,
}));

export default useHeaderActionStyles;
